import Invoices from "../components/Invoices/Invoices";
import Invoice from "../components/Invoices/Invoice";

const invoices = [
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true,
  },
  {
    path: '/invoices/new',
    name: 'InvoiceAdd',
    component: Invoice,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true
  },
  {
    path: '/invoices/edit/:invoice_id',
    name: 'InvoiceEdit',
    component: Invoice,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true
  },
];

export default invoices;



// WEBPACK FOOTER //
// ./src/router/invoices.js